import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import stringSimilarity from "string-similarity";
import { Addons } from "../../components";
import { isRTL, getGlobalCurrency } from "../../reducers";
import * as addonsActions from "../../actions/addonsActions";
import { addonsContainerTypes, addonsContainerDefaultProps } from "../../types";

export class AddonsContainer extends Component {
  onAddonIncrementClick = (groupId, addonCode, msg) => {
    const { actions } = this.props;
    actions.onAddonAdd(groupId, addonCode, msg);
  };

  onAddonDecrementClick = (groupId, addonCode) => {
    const { actions } = this.props;
    actions.onAddonRemove(groupId, addonCode);
  };
  onCancel = groupId => {
    const { actions, onCancel } = this.props;
    actions.onCancelAddons(groupId);
    onCancel();
  };

  onConfirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
  };

  render() {
    const {
      selectedAddonsGroup,
      addonsByPaxIndex,
      selectedPaxId,
      globalCurrency,
      isRtl,
      titles
    } = this.props;
    return (
      <Addons
        addons={addonsByPaxIndex}
        selectedAddonsGroup={selectedAddonsGroup[selectedPaxId] || {}}
        id={selectedPaxId}
        roomNumber={selectedPaxId + 1}
        onAddonIncrementClick={this.onAddonIncrementClick}
        onAddonDecrementClick={this.onAddonDecrementClick}
        onCancel={this.onCancel}
        onConfirm={this.onConfirm}
        globalCurrency={globalCurrency}
        isRtl={isRtl}
        headerTitle={titles.AddonsTitle}
        subHeaderTitle={titles.AddonsSubtitle}
        confirmTitle={titles.BtnConfirm}
        noThanksTitle={titles.NoThanks}
      />
    );
  }
}

AddonsContainer.defaultProps = addonsContainerDefaultProps;

AddonsContainer.propTypes = addonsContainerTypes;

function mapStateToProps(store) {
  const { addonImagesLookupTable } = store;
  const globalCurrency = getGlobalCurrency(store);
  const state = {
    isRtl: isRTL(store),
    globalCurrency,
    titles: store.titles,
    addons: store.addons,
    selectedAddonsGroup: store.selectedAddonsGroup,
    selectedPaxId: store.selectedPaxId,
    addonsByPaxIndex:
      store.addons[store.selectedPaxId] &&
      store.addons[store.selectedPaxId].map(addon => {
        //TODO: this is bad practice to do in mapState, we need a memoized selector
        const bestMatch = stringSimilarity.findBestMatch(
          addon.id,
          Object.keys(addonImagesLookupTable)
        ).bestMatch;
        const useBestMatch = bestMatch.rating > 0.8;
        return {
          ...addon,
          imageURL: useBestMatch
            ? addonImagesLookupTable[bestMatch.target]
            : addonImagesLookupTable.default
        };
      })
  };
  return state;
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...addonsActions
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddonsContainer);



// WEBPACK FOOTER //
// ./src/containers/AddonsContainer/AddonsContainers.js